import { Heading } from "@/components/Typography";
import { IconButton } from "@/components/Button";
import { PinterestButton } from "@/components/WineDetail/PageShare/PinterestButton";
import { ClipboardButton } from "@/components/WineDetail/PageShare/ClipboardButton";
import { FlexColumn, FlexRow } from "@/components/layout/FlexBox";
import { Wine, WP_Image } from "@/models";

import s from "./PageShare.module.scss";

interface PageShareProps {
	label: string;
	wine: Wine;
	productImage?: WP_Image;
}

function PageShare({ wine, label, productImage }: PageShareProps) {
	return (
		<FlexColumn gap={16}>
			<Heading as="p" sizeMobile="xxs" sizeDesktop="xxs">
				{label}
			</Heading>
			<FlexRow gap={8}>
				<div className={s.svgWrapper}>
					<IconButton
						as="a"
						href={`https://wa.me/?text=${wine.name}%0A%0A${wine.permalink}`}
						icon="whatsapp"
						label="Deel via Whatsapp"
						target="_blank"
						rel="noreferrer noopener"
					/>
				</div>
				<div className={s.svgWrapper}>
					<IconButton
						as="a"
						href={`mailto:?subject=Bekijk deze wijn&body=Bekijk de wijn: ${wine.name} via deze link: ${wine.permalink}`}
						icon="mail"
						label="Deel via E-mail"
					/>
				</div>
				<ClipboardButton />
				<PinterestButton
					url={wine.permalink}
					img={productImage}
					title={wine.name}
				/>
			</FlexRow>
		</FlexColumn>
	);
}

export default PageShare;
